import InputLabel from "@/atoms-react/input/Input.react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export type PasswordOutput = {
  password: string;
};

type AccountSecurityPasswordProps = {
  onChange: (output: PasswordOutput) => void;
  label?: string;
};

export const PasswordInput = ({ onChange = () => {}, label }: AccountSecurityPasswordProps) => {
  const { t } = useTranslation(["pass"]);
  const [password, setPassword] = useState<string>("");
  useEffect(() => {
    onChange({ password });
  }, [password]);

  return (
    <>
      <InputLabel
        autoFocus
        type="password"
        placeholder={t("flow.id_control.input.placeholder_password")}
        value={password}
        onChange={(value: string) => setPassword(value)}
        label={label ? label : t("flow.id_control.input.password")}
        className={"mb-1"}
      />
    </>
  );
};
